import { useEffect, useState } from "react";

import { getPhotoDetails } from "shared/api/claims/api";
import { Photo } from "shared/api/types";

export const useRefreshedPhoto = (photoId: string, srcExpire?: string) => {
  const [refreshedPhoto, setRefreshedPhoto] = useState<Photo | null>(null);

  useEffect(() => {
    if (!srcExpire) return;

    const expire = new Date(srcExpire);

    const timeout = setTimeout(() => {
      getPhotoDetails({ photoID: photoId, includeSrcURLs: true }).then(
        (res) => {
          setRefreshedPhoto(res.data);
        }
      );
    }, expire.getTime() - Date.now());

    return () => clearTimeout(timeout);
  });

  return refreshedPhoto;
};
